import { Button, CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import tenantPagesRoleManagement from '../../staticRoleManagement/tenantRoleManagement'
import useStyles from './styles/TenantFooter.styles'

interface TenantFooterProps {
  isSubmitting: boolean
  loadingForGenerateTenant: boolean
}

export const TenantFooter: React.FC<TenantFooterProps> = ({
  isSubmitting,
  loadingForGenerateTenant
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const hasnAccessToAddNewTenant = tenantPagesRoleManagement
    .find((item) => item.route === '/tenant/create')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  return (
    <div className={classes.footer}>
      <Button
        disabled={isSubmitting || !hasnAccessToAddNewTenant}
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        fullWidth={matches}>
        {getTranslate('Save Tenant')}
        {loadingForGenerateTenant && (
          <CircularProgress className={classes.circularProgress} size={16} />
        )}
      </Button>
    </div>
  )
}
